import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { t } from "@/lib/i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const IMG = "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function AuthLayout({ title, subtitle, children, wide }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-5">
      <div className="hidden lg:block lg:col-span-2 relative bg-slate-900">
        <img src={IMG} alt="Truck on open road" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 to-transparent" />
        <div className="absolute bottom-0 p-10 text-white">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400">{t("Verified · Credit-based · Direct")}</p>
          <p className="font-display font-black text-3xl mt-3 leading-tight">{t("The exchange where bulk freight finds its truck.")}</p>
        </div>
      </div>
      <div className="lg:col-span-3 flex flex-col px-6 py-10 md:px-16 overflow-y-auto relative overflow-x-hidden">
        <div className="pointer-events-none hidden md:block absolute -right-24 top-24 w-48 h-48 rounded-full bg-amber-600" aria-hidden="true" />
        <div className="absolute top-6 right-6 z-10"><LanguageSwitcher /></div>
        <Link to="/" className="flex items-center gap-2 mb-12 relative">
          <Logo className="text-3xl" tagline />
        </Link>
        <div className={`w-full ${wide ? "max-w-2xl" : "max-w-md"} hf-rise relative`}>
          <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight">{title}</h1>
          {subtitle && <p className="text-slate-600 mt-2">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
